import React from 'react';
export interface AdminTab {
  id: string;
  label: string;
  icon?: React.ReactNode;
}
interface AdminTabsProps {
  tabs: readonly AdminTab[] | AdminTab[];
  activeTab: string;
  onTabChange: (id: string) => void;
  /**
   * Laat de tab-rij op grotere schermen WRAPPEN i.p.v. horizontaal scrollen.
   * Zet dit aan voor tab-rijen met veel tabs (bv. 6+), zodat de laatste tab
   * niet off-screen verdwijnt in de scroll-container en daardoor onvindbaar
   * wordt. Mobiel blijft de rij horizontaal scrollen (met fade-indicatoren).
   * Default `false` → bestaande scroll-only-gedrag voor alle huidige pagina's.
   */
  wrapOnDesktop?: boolean;
}
export function AdminTabs({
  tabs,
  activeTab,
  onTabChange,
  wrapOnDesktop = false
}: AdminTabsProps) {
  return <div className="mb-4 sm:mb-6" data-id="element-7653">
      {/* Scroll container with fade indicators */}
      <div className="relative" data-id="element-7654">
        {/* Left fade — only meaningful while the row scrolls (mobile) */}
        <div className="absolute left-0 top-0 bottom-0 w-4 bg-gradient-to-r from-white/80 to-transparent z-10 pointer-events-none sm:hidden" data-id="element-7655" />
        {/* Right fade */}
        <div className="absolute right-0 top-0 bottom-0 w-4 bg-gradient-to-l from-white/80 to-transparent z-10 pointer-events-none sm:hidden" data-id="element-7656" />

        <div className={`w-full overflow-x-auto hide-scrollbar ${wrapOnDesktop ? 'sm:overflow-visible' : ''}`} data-id="element-7657">
          <div className={`flex gap-1 bg-gray-100 rounded-lg p-1 w-fit min-w-min ${wrapOnDesktop ? 'sm:w-full sm:flex-wrap' : ''}`} role="tablist" aria-label="Tab navigatie" data-id="element-7658">
            {tabs.map(tab => <button key={tab.id} onClick={() => onTabChange(tab.id)} role="tab" aria-selected={activeTab === tab.id} aria-controls={`tabpanel-${tab.id}`} className={`flex items-center gap-1.5 px-3.5 py-2 sm:px-4 sm:py-2 text-sm rounded-md transition-colors whitespace-nowrap focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:outline-none ${activeTab === tab.id ? 'bg-white text-gray-900 font-medium shadow-sm' : 'text-gray-500 hover:text-gray-700'}`} data-id="element-7659">
                {tab.icon}
                {tab.label}
              </button>)}
          </div>
        </div>
      </div>
    </div>;
}